import http from '@/utils/request';

/**
 * 查询事件列表
 */
export const queryEvent = (params) => http.get({
  url: '/event/queryEvent',
  params,
});

/**
 * 查询事件聚合
 */
export const queryEventAgg = (data) => http.post({
  url: '/eventAnalyze/queryEventAgg',
  data,
});

/**
 * 查询事件明细
 */
export const queryEventDetail = (data) => http.post({
  url: '/eventAnalyze/queryEventDetail',
  data,
});

/**
 * 编辑事件
 */
export const modifyEvent = (data) => http.post({
  url: '/event/modifyEvent',
  data,
});

/**
 * 查询事件数量
 */
export const queryEventCount = (data) => http.post({
  url: '/eventAnalyze/queryEventCount',
  data,
});

/**
 * 查询系统信息
 */
export const queryOsInfo = (params) => http.get({
  url: '/os/queryOsInfo',
  params,
});

/**
 * 查询系统信息
 */
export const queryEventCountTendency = (data) => http.post({
  url: '/eventAnalyze/queryEventCountTendency',
  data,
});

/**
 * 查询事件用户top
 */
export const queryEventUserTop = (data) => http.post({
  url: '/eventAnalyze/queryEventUserTop',
  data,
});

/**
 * 查询事件系统统计
 */
export const queryEventOsStat = (data) => http.post({
  url: '/eventAnalyze/queryEventOsStat',
  data,
});

/**
 * 查询事件系统版本趋势
 */
export const queryEventOsVersionTendency = (data) => http.post({
  url: '/eventAnalyze/queryEventOsVersionTendency',
  data,
});

/**
 * 实时事件导出明细
 */
export const eventAnalyzeExport = '/eventAnalyze/queryEvent/download';
// (data) => http.post({
//   url: '/apm/eventAnalyze/queryEvent/download',
//   data,
// });

/**
 * 查询链路
 */
export const queryEventTrace = (params) => http.get({
  url: '/eventTrace/query',
  params,
});

/**
 * 删除链路
 */
export const deleteEventTrace = (data) => http.post({
  url: '/eventTrace/delete',
  data,
});

/**
 * 修改链路
 */
export const modifyEventTrace = (data) => http.post({
  url: '/eventTrace/modify',
  data,
});

/**
 * 保存链路
 */
export const saveEventTrace = (data) => http.post({
  url: '/eventTrace/save',
  data,
});

/**
 * 查询链路分析概要信息
 */
export const queryEventTraceAnalyzeSummary = (params) => http.get({
  url: '/eventTraceAnalyze/querySummary',
  params,
});
